import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';

@Injectable()

export class ReportEndpoint extends EndpointFactory {
  private readonly getPdfRegulatoryItemCountsEndpointPath: string = "/api/reportService/getPdfRegulatoryItemCounts";
  private readonly getExcelRegulatoryItemCountsEndpointPath: string = "/api/reportService/getExcelRegulatoryItemCounts";
  private readonly getPdfMinistryOverviewEndpointPath: string = "/api/reportService/getPdfMinistryOverview";
  private readonly getPdfPermitQuarterlyEndpointPath: string = "/api/reportService/getPdfPermitQuarterly";
  private readonly getExcelPermitQuarterlyEndpointPath: string = "/api/reportService/getExcelPermitQuarterly";
  private readonly getExcelMinistryOverviewEndpointPath: string = "/api/reportService/getExcelMinistryOverview";
  private readonly getPdfRegulatoryUpdateChangesEndpointPath: string = "/api/reportService/getPdfRegulatoryUpdateChanges";
  private readonly getExcelRegulatoryUpdateChangesEndpointPath: string = "/api/reportService/getExcelRegulatoryUpdateChanges";
  private readonly getPdfAnnualPlanMinistryReportEndpointPath: string = "/api/reportService/getPdfAnnualPlanMinistryReport";
  private readonly getExcelAnnualPlanMinistryReportEndpointPath: string = "/api/reportService/getExcelAnnualPlanMinistryReport";
  private readonly getPdfAgencyOverviewEndpointPath: string = "/api/reportService/getPdfAgencyOverview";
  private readonly getExcelAgencyOverviewEndpointPath: string = "/api/reportService/getExcelAgencyOverview";


  get getPdfRegulatoryItemCountsEndpointUrl() { return this.configurations.baseUrl + this.getPdfRegulatoryItemCountsEndpointPath; }
  get getExcelRegulatoryItemCountsEndpointUrl() { return this.configurations.baseUrl + this.getExcelRegulatoryItemCountsEndpointPath; }
  get getPdfMinistryOverviewEndpointUrl() { return this.configurations.baseUrl + this.getPdfMinistryOverviewEndpointPath; }
  get getPdfPermitQuarterlyEndpointUrl() { return this.configurations.baseUrl + this.getPdfPermitQuarterlyEndpointPath; }
  get getExcelPermitQuarterlyEndpointUrl() { return this.configurations.baseUrl + this.getExcelPermitQuarterlyEndpointPath; }
  get getExcelMinistryOverviewEndpointUrl() { return this.configurations.baseUrl + this.getExcelMinistryOverviewEndpointPath; }
  get getPdfRegulatoryUpdateChangesEndpointUrl() { return this.configurations.baseUrl + this.getPdfRegulatoryUpdateChangesEndpointPath; }
  get getExcelRegulatoryUpdateChangesEndpointUrl() { return this.configurations.baseUrl + this.getExcelRegulatoryUpdateChangesEndpointPath; }
  get getPdfAnnualPlanMinistryReportEndpointUrl() { return this.configurations.baseUrl + this.getPdfAnnualPlanMinistryReportEndpointPath; }
  get getExcelAnnualPlanMinistryReportEndpointUrl() { return this.configurations.baseUrl + this.getExcelAnnualPlanMinistryReportEndpointPath; }
  get getPdfAgencyOverviewEndpointUrl() { return this.configurations.baseUrl + this.getPdfAgencyOverviewEndpointPath; }
  get getExcelAgencyOverviewEndpointUrl() { return this.configurations.baseUrl + this.getExcelAgencyOverviewEndpointPath; }


  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getPdfRegulatoryItemCounts<T>(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfRegulatoryItemCountsEndpointUrl}/${departmentId}/${legislationId}/${agencyId}/${userProfileId}/${reportName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfRegulatoryItemCountsUrl<T>(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string): string {
    let endpointUrl = `${this.getPdfRegulatoryItemCountsEndpointUrl}/${departmentId}/${legislationId}/${agencyId}/${userProfileId}/${reportName}`;
    return endpointUrl;
  }

  getExcelRegulatoryItemCounts<T>(departmentId?: string, legislationId?: string, agencyId?: string, userProfileId?: string, reportName?: string): Observable<Blob> {
    let endpointUrl = `${this.getExcelRegulatoryItemCountsEndpointUrl}/${departmentId}/${legislationId}/${agencyId}/${userProfileId}/${reportName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfMinistryOverview<T>(departmentId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfMinistryOverviewEndpointUrl}/${departmentId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfMinistryOverviewUrl<T>(departmentId?: string, userProfileId?: string): string {
    let endpointUrl = `${this.getPdfMinistryOverviewEndpointUrl}/${departmentId}/${userProfileId}`;
    return endpointUrl;
  }

  getPdfPermitQuarterly<T>(departmentId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfPermitQuarterlyEndpointUrl}/${departmentId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfPermitQuarterlyUrl<T>(departmentId?: string, userProfileId?: string): string {
    let endpointUrl = `${this.getPdfPermitQuarterlyEndpointUrl}/${departmentId}/${userProfileId}`;
    return endpointUrl;
  }

  getExcelPermitQuarterly<T>(departmentId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getExcelPermitQuarterlyEndpointUrl}/${departmentId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getExcelMinistryOverview<T>(departmentId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getExcelMinistryOverviewEndpointUrl}/${departmentId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfRegulatoryUpdateChanges<T>(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfRegulatoryUpdateChangesEndpointUrl}/${departmentId}/${agencyId}/${dateType}/${startDate}/${endDate}/${userProfileId}/${reportName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfRegulatoryUpdateChangesUrl<T>(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string): string {
    let endpointUrl = `${this.getPdfRegulatoryUpdateChangesEndpointUrl}/${departmentId}/${agencyId}/${dateType}/${startDate}/${endDate}/${userProfileId}/${reportName}`;
    return endpointUrl;
  }

  getExcelRegulatoryUpdateChanges<T>(departmentId?: string, agencyId?: string, dateType?: string, startDate?: string, endDate?: string, userProfileId?: string, reportName?: string): Observable<Blob> {
    let endpointUrl = `${this.getExcelRegulatoryUpdateChangesEndpointUrl}/${departmentId}/${agencyId}/${dateType}/${startDate}/${endDate}/${userProfileId}/${reportName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }


  getPdfAnnualPlanMinistryReport<T>(departmentId?: string, annualPlanYearVldID?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfAnnualPlanMinistryReportEndpointUrl}/${departmentId}/${annualPlanYearVldID}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfAnnualPlanMinistryReportUrl<T>(departmentId?: string, annualPlanYearVldID?: string): string {
    let endpointUrl = `${this.getPdfAnnualPlanMinistryReportEndpointUrl}/${departmentId}/${annualPlanYearVldID}`;
    return endpointUrl;
  }

  getExcelAnnualPlanMinistryReport<T>(departmentId?: string, annualPlanYearVldID?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfAnnualPlanMinistryReportEndpointUrl}/${departmentId}/${annualPlanYearVldID}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfAgencyOverview<T>(agencyId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getPdfAgencyOverviewEndpointUrl}/${agencyId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

  getPdfAgencyOverviewUrl<T>(agencyId?: string, userProfileId?: string): string {
    let endpointUrl = `${this.getPdfAgencyOverviewEndpointUrl}/${agencyId}/${userProfileId}`;
    return endpointUrl;
  }

  getExcelAgencyOverview<T>(agencyId?: string, userProfileId?: string): Observable<Blob> {
    let endpointUrl = `${this.getExcelAgencyOverviewEndpointUrl}/${agencyId}/${userProfileId}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }

}
